const INTERNAL_DOMAINS = [
  'eoibd.cat',
  'www.eoibd.cat',
  'eoi-web-omavercel',
  process.env.EDITORA_URL,
].filter(Boolean);

const HTTP_REGEX = /^https?:\/\//;

export function isExternalLink(url) {
  if (typeof url !== 'string') {
    return false;
  }

  if (!HTTP_REGEX.test(url)) {
    return false;
  }
  try {
    const { hostname } = new URL(url);
    return !INTERNAL_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
}
